import { TimelineStage } from './TimelineStage';
import { OwnershipChangeType } from '../ownership-share-tracking/OwnershipChangeType';

export enum OwnershipMilestoneId {
  D_S1_CON_TRI = 'D_S1_CON_TRI',
  D_S1_DIV_AUT = 'D_S1_DIV_AUT',
  D_S1_NBO_SUB = 'D_S1_NBO_SUB',
  D_S1_SEL_NBO = 'D_S1_SEL_NBO',
  D_S2_BO_SUB = 'D_S2_BO_SUB',
  D_S2_SEL_BO = 'D_S2_SEL_BO',
  D_S3_DIV_APR = 'D_S3_DIV_APR',
  D_S3_CON_SIG = 'D_S3_CON_SIG',
  D_S4_END_PRO = 'D_S4_END_PRO',

  A_S1_DEC_PRO = 'A_S1_DEC_PRO',
  A_S1_NBO_APR = 'A_S1_NBO_APR',
  A_S1_NBO_SUB = 'A_S1_NBO_SUB',
  A_S2_BO_APR = 'A_S2_BO_APR',
  A_S2_BO_SUB = 'A_S2_BO_SUB',
  A_S3_CON_SIG = 'A_S3_CON_SIG',
  A_S4_END_PRO = 'A_S4_END_PRO',
}
export const OwnershipMilestoneIdToOwnershipChangeType: Record<OwnershipMilestoneId, OwnershipChangeType> = {
  D_S1_CON_TRI: OwnershipChangeType.DIVESTMENT,
  D_S1_DIV_AUT: OwnershipChangeType.DIVESTMENT,
  D_S1_NBO_SUB: OwnershipChangeType.DIVESTMENT,
  D_S1_SEL_NBO: OwnershipChangeType.DIVESTMENT,
  D_S2_BO_SUB: OwnershipChangeType.DIVESTMENT,
  D_S2_SEL_BO: OwnershipChangeType.DIVESTMENT,
  D_S3_DIV_APR: OwnershipChangeType.DIVESTMENT,
  D_S3_CON_SIG: OwnershipChangeType.DIVESTMENT,
  D_S4_END_PRO: OwnershipChangeType.DIVESTMENT,

  A_S1_DEC_PRO: OwnershipChangeType.ACQUISITION,
  A_S1_NBO_APR: OwnershipChangeType.ACQUISITION,
  A_S1_NBO_SUB: OwnershipChangeType.ACQUISITION,
  A_S2_BO_APR: OwnershipChangeType.ACQUISITION,
  A_S2_BO_SUB: OwnershipChangeType.ACQUISITION,
  A_S3_CON_SIG: OwnershipChangeType.ACQUISITION,
  A_S4_END_PRO: OwnershipChangeType.ACQUISITION,
};
export const OwnershipMilestoneIdToStage: Record<OwnershipMilestoneId, TimelineStage> = {
  D_S1_CON_TRI: TimelineStage.NON_BINDING_OFFER,
  D_S1_DIV_AUT: TimelineStage.NON_BINDING_OFFER,
  D_S1_NBO_SUB: TimelineStage.NON_BINDING_OFFER,
  D_S1_SEL_NBO: TimelineStage.NON_BINDING_OFFER,
  D_S2_BO_SUB: TimelineStage.BINDING_OFFER,
  D_S2_SEL_BO: TimelineStage.BINDING_OFFER,
  D_S3_DIV_APR: TimelineStage.CONTRACTING,
  D_S3_CON_SIG: TimelineStage.CONTRACTING,
  D_S4_END_PRO: TimelineStage.COMPLETE,

  A_S1_DEC_PRO: TimelineStage.NON_BINDING_OFFER,
  A_S1_NBO_APR: TimelineStage.NON_BINDING_OFFER,
  A_S1_NBO_SUB: TimelineStage.NON_BINDING_OFFER,
  A_S2_BO_APR: TimelineStage.BINDING_OFFER,
  A_S2_BO_SUB: TimelineStage.BINDING_OFFER,
  A_S3_CON_SIG: TimelineStage.CONTRACTING,
  A_S4_END_PRO: TimelineStage.COMPLETE,
};

export const DivestmentMilestoneIds: OwnershipMilestoneId[] = Object.values(OwnershipMilestoneId)
  .filter(x => OwnershipMilestoneIdToOwnershipChangeType[x] === OwnershipChangeType.DIVESTMENT);

export const AcquisitionMilestoneIds: OwnershipMilestoneId[] = Object.values(OwnershipMilestoneId)
  .filter(x => OwnershipMilestoneIdToOwnershipChangeType[x] === OwnershipChangeType.ACQUISITION);

export const OwnershipChangeTypeToOwnershipMilestoneIds: Record<OwnershipChangeType, OwnershipMilestoneId[]> = {
  LEGACY: [],
  INITIAL: [],
  DIVESTMENT: DivestmentMilestoneIds,
  ACQUISITION: AcquisitionMilestoneIds,
};
export const OwnershipChangeTypeToStageToMilestoneIds: Record<OwnershipChangeType, Record<TimelineStage, OwnershipMilestoneId[]>> = {
  LEGACY: {
    NON_BINDING_OFFER: [],
    BINDING_OFFER: [],
    CONTRACTING: [],
    COMPLETE: [],
  },
  INITIAL: {
    NON_BINDING_OFFER: [],
    BINDING_OFFER: [],
    CONTRACTING: [],
    COMPLETE: [],
  },
  DIVESTMENT: {
    NON_BINDING_OFFER: [
      OwnershipMilestoneId.D_S1_CON_TRI,
      OwnershipMilestoneId.D_S1_DIV_AUT,
      OwnershipMilestoneId.D_S1_NBO_SUB,
      OwnershipMilestoneId.D_S1_SEL_NBO,
    ],
    BINDING_OFFER: [
      OwnershipMilestoneId.D_S2_BO_SUB,
      OwnershipMilestoneId.D_S2_SEL_BO,
    ],
    CONTRACTING: [
      OwnershipMilestoneId.D_S3_DIV_APR,
      OwnershipMilestoneId.D_S3_CON_SIG,
    ],
    COMPLETE: [OwnershipMilestoneId.D_S4_END_PRO],
  },
  ACQUISITION: {
    NON_BINDING_OFFER: [
      OwnershipMilestoneId.A_S1_DEC_PRO,
      OwnershipMilestoneId.A_S1_NBO_APR,
      OwnershipMilestoneId.A_S1_NBO_SUB,
    ],
    BINDING_OFFER: [
      OwnershipMilestoneId.A_S2_BO_APR,
      OwnershipMilestoneId.A_S2_BO_SUB,
    ],
    CONTRACTING: [OwnershipMilestoneId.A_S3_CON_SIG],
    COMPLETE: [OwnershipMilestoneId.A_S4_END_PRO],
  },
};

export const OwnershipMilestoneIdIsNboApproval: Partial<Record<OwnershipMilestoneId, boolean>> = {
  D_S1_DIV_AUT: true,
  A_S1_NBO_APR: true,
}
export const OwnershipMilestoneIdIsBoApproval: Partial<Record<OwnershipMilestoneId, boolean>> = {
  D_S3_DIV_APR: true,
  A_S2_BO_APR: true,
}

export const OwnershipMilestoneIdToTitle: Record<OwnershipMilestoneId, string> = {
  D_S1_CON_TRI: 'Divestment Consideration Trigger',
  D_S1_DIV_AUT: 'NBO Divestment Authorization',
  D_S1_NBO_SUB: 'NBO Submission',
  D_S1_SEL_NBO: 'Steer Co Select Preferred NBO',
  D_S2_BO_SUB: 'BO Submission',
  D_S2_SEL_BO: 'Steer Co Select Preferred BO',
  D_S3_DIV_APR: 'BO Divestment Approved',
  D_S3_CON_SIG: 'Contracts Signed',
  D_S4_END_PRO: 'End of Process',

  A_S1_DEC_PRO: 'Decision to Proceed',
  A_S1_NBO_APR: 'NBO Approval',
  A_S1_NBO_SUB: 'NBO Submission',
  A_S2_BO_APR: 'BO Approval',
  A_S2_BO_SUB: 'BO Submission',
  A_S3_CON_SIG: 'Contracts Signed',
  A_S4_END_PRO: 'End of Process',
};
export const OwnershipMilestoneIdToDescription: Record<OwnershipMilestoneId, string> = {
  D_S1_CON_TRI: 'The date that the decision was taken to explore the possibility of Divestment.',
  D_S1_DIV_AUT: `The date that the NBO - Divestment Authorization was given by the Board to explore the Divestment
  Opportunities presented by the market.`,
  D_S1_NBO_SUB: 'The deadline for the submission of Non-Binding Offers.',
  D_S1_SEL_NBO: 'The decision by the Steer Co to select the preferred Non-Binding Offer bid.',

  D_S2_BO_SUB: 'The deadline date for when Binding Offers have to be submitted by.',
  D_S2_SEL_BO: 'The decision by the Steer Co to select the preferred Binding Offer bid.',

  D_S3_DIV_APR: `The date that the BO - Divestment Approval was given by the Board to proceed with the preferred
  Divestment bid.`,
  D_S3_CON_SIG: 'The date that the Contracts were signed.',

  D_S4_END_PRO: `The date that either: A) the Offer was Accepted & the contract was signed to legally divest
  the project from the pipeline; or B) the Offer was rejected &/or the Divestment was aborted.`,

  A_S1_DEC_PRO: `The date that the decision was taken by Partnerships & Transactions and the Development N-1/N-2 to
  proceed with pursuing the Acquisition Opportunity`,
  A_S1_NBO_APR: 'The date that the Non-Binding Offer was approved by the board',
  A_S1_NBO_SUB: 'The date that the Non-Binding Offer was formally submitted',
  A_S2_BO_APR: 'The date that the Binding Offer was approved by the board',
  A_S2_BO_SUB: 'The date that the Binding Offer was formally submitted',
  A_S3_CON_SIG: 'The date that the Contracts were signed',
  A_S4_END_PRO: `The date that either: A) the Offer was Accepted & the contract was signed to acquire the project shares
  into the Development Pipeline now or in the future; or B) the Offer was rejected &/or the Divestment was aborted.`,
};
